import React, { useEffect } from "react";

import CapturingSuccessStories from "./capturing-success-stories/Capturing_Success_Stories";
import Free_Consultation from "../home/free-consultation/Free_Consultation";

function Gallery() {
  return (
    <>
      {/* Gallery Section */}
      <div>
        <CapturingSuccessStories />
      </div>

      {/* Consultation Section */}
      <div>
        <Free_Consultation />
      </div>
    </>
  );
}

export default Gallery;
